// this is an autogenerated file from App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment/BottomAction/Content/mutation-seat.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_PatientOverlay_Content_Content_Appointments_TabContent_Content_AppointmentsList_Content_Appointment_BottomAction_Content(
  $id: uuid!
  $provider_id: numeric!
  $assistant_id: numeric!
  $chair_id: numeric!
) {
  vaxiom_appointment_booking_seat(
    id: $id
    provider_id: $provider_id
    assistant_id: $assistant_id
    chair_id: $chair_id
  ) {
    id
    appointment_booking {
      id
      _id
      state
      start_time
      end_time
      local_start_date
      local_start_time
      provider_id
      assistant_id
      chair_id
      seated_chair {
        id
        _id
        code
        resource {
          id
          organization {
            id
            _id
          }
        }
      }
      chair {
        id
        resource {
          id
          organization {
            id
            name
          }
        }
      }
      provider {
        id
        employment_contract {
          id
          person {
            id
            first_name
            last_name
          }
        }
      }
      assistant {
        id
        employment_contract {
          id
          person {
            id
            first_name
            last_name
          }
        }
      }
    }
  }
}

`